import { motion } from "framer-motion";
import { KineticHeading } from "./KineticHeading";

export const PageHero = ({ eyebrow, lines, lead, children }) => (
  <section className="band relative overflow-hidden" data-testid="page-hero">
    <div
      aria-hidden
      className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-band-foreground/15"
    />
    <div
      aria-hidden
      className="pointer-events-none absolute -bottom-32 right-1/4 h-72 w-72 rounded-full border border-band-foreground/10"
    />
    <div className="wrap relative flex flex-col gap-5 py-16 sm:py-20">
      <motion.p
        className="eyebrow !text-band-foreground/70"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {eyebrow}
      </motion.p>
      <KineticHeading
        as="h1"
        lines={lines}
        className="max-w-4xl font-display text-4xl font-extrabold tracking-tight text-band-foreground sm:text-5xl lg:text-6xl"
        delay={0.1}
        testid="page-hero-headline"
      />
      {lead && (
        <motion.p
          className="max-w-2xl text-lg leading-relaxed text-band-muted"
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
        >
          {lead}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
